import { Steps } from 'antd';
import { MainLayout } from 'components';
import { ReactNode, useEffect } from 'react';
import useCategoryManagementStore from 'store/categoryManagementStore';
import { CheckIcon } from 'assets/svg';
import pageTitleStore from 'store/pageTitleStore';

interface IProps {
  children: ReactNode;
  isLoading?: boolean;
}

export default function CreateCartPage(props: IProps): JSX.Element {
  const { children, isLoading } = props;
  const step = useCategoryManagementStore((state) => state.step);
  const infoSteps = [
    {
      title: 'Chọn mẫu',
      icon: <>{step >= 1 ? <CheckIcon /> : '1'}</>,
      className: 'step-first',
    },
    {
      title: 'Kiểm tra thông tin',
      icon: <>{step >= 2 ? <CheckIcon /> : '2'}</>,
      className: 'step-last',
    },
  ];
  const setTitle = pageTitleStore((state) => state.setTitle);
  const setBreadcrumb = pageTitleStore((state) => state.setBreadcrumb);
  useEffect(() => {
    setTitle('Tạo giỏ hàng');
    setBreadcrumb([{ title: <a href="/">Giỏ hàng / Tạo giỏ hàng</a> }]);
  }, []);

  return (
    <MainLayout isLoading={isLoading}>
      <Steps
        current={step}
        className="add-category-step mb-7"
        items={infoSteps}
        // descriptionMaxWidth={60}
      />
      <div className="p-1">{children}</div>
    </MainLayout>
  );
}
